import { Component, Renderer2 } from '@angular/core';
import { DatabaseService } from 'src/_services/DatabaseService'
import { AuthGuard } from './auth.guard';
import { sessionStorage } from './localstorage.service';
import { BnNgIdleService } from 'bn-ng-idle';
import { Router } from '@angular/router';
import * as moment from 'moment';
// import
// import { LocalStorage } from './localstorage.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'abacusdesk';
  login_data: any = {};
  kei_user: any;
  today_date = moment(new Date()).format('YYYY-MM-DD');
  constructor(public serve: DatabaseService, public session: sessionStorage, public router: Router, public renderer: Renderer2, private bnIdle: BnNgIdleService) {
    this.session.getSession()
      .subscribe(resp => {
        this.login_data = resp.data;
      });


    const storedData = moment(JSON.parse(localStorage.getItem("date"))).format("YYYY-MM-DD")
    console.log(storedData);


    this.date_diff(this.today_date, storedData);


  }
  ngOnInit(): void {
    window.onload = (event) => {
      document.getElementById("splashScreen").classList.add("splashScreenFadeHide")
    }
    document.getElementById("splashScreen").addEventListener('transitionend', (e) => {
      document.getElementById("splashScreen").style.display = 'none'
    })

    this.bnIdle.startWatching(1800).subscribe((isTimedOut: boolean) => {
      if (isTimedOut) {
        this.session.LogOutSession();
        this.router.navigate(['']);
        this.kei_user = JSON.parse(localStorage.getItem('st_user')) || [];
        this.kei_user = {};
        this.kei_user.st_log = false;
        localStorage.removeItem('st_user');
      }

    });

  };




  date_diff(today, storedDate) {

    var a = moment(today);
    var b = moment(storedDate);
    var c = b.diff(a, 'days');
    // console.log(typeof (c));
    // console.log(c);
    if (c != 0) {
      this.session.LogOutSession();
      this.router.navigate(['']);
      this.kei_user = JSON.parse(localStorage.getItem('st_user')) || [];
      this.kei_user = {};
      this.kei_user.st_log = false;
      localStorage.removeItem('st_user');
    }

  }
}
